import React, { lazy, Suspense } from 'react';
import { withTranslation } from "react-i18next";
import { ICON_NOTE } from '../../common/images-s3';
const ImageLoader = lazy(() => import('../../common/image-loader'));

class PopupSwitchBusinessIndividual extends React.Component {

    render() {
        const {t} = this.props
        return (
            <>
                <div className="popup">
                    <div className="c-swtich-business-individual">
                        <div className="body">
                            <Suspense fallback={null}>
                                <ImageLoader type='image' src={ICON_NOTE} />
                            </Suspense>
                            <p className='info'>
                                {this.props.data?.title.includes('Business') || this.props.data?.title.includes('Perniagaan') ? t('zakat_switch_business') : t('zakat_switch_individual') }
                            </p>
                            <button type='button' className='btn btn-dark btn-okay' onClick={this.props.handleOkay}> Okay</button>
                            <button type='button' className='btn btn-transparent btn-cancel' onClick={this.props.handleClose}>Exit</button>
                        </div>
                    </div>
                </div>
                <div className="popup-backdrop"></div>
            </>
        )
    }
}

export default (withTranslation()(PopupSwitchBusinessIndividual));